// Class: openfl.filters._GlowFilter.InnerCombineKnockoutShader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
var $extend = require("./../../../extend_stub").default;
function openfl_filters_BitmapFilterShader() {return require("./../../../openfl/filters/BitmapFilterShader");}

// Constructor

var InnerCombineKnockoutShader = function() {
	if(this.__glFragmentSource == null) {
		this.__glFragmentSource = "\n\t\tuniform sampler2D openfl_Texture;\n\t\tuniform sampler2D sourceBitmap;\n\t\tvarying vec4 textureCoords;\n\n\t\tvoid main(void) {\n\t\t\tvec4 src = texture2D(sourceBitmap, textureCoords.xy);\n\t\t\tvec4 glow = texture2D(openfl_Texture, textureCoords.zw);\n\n\t\t\tgl_FragColor = glow * src.a;\n\t\t}\n\t";
	}
	if(this.__glVertexSource == null) {
		this.__glVertexSource = "attribute vec4 openfl_Position;\n\t\tattribute vec2 openfl_TextureCoord;\n\t\tuniform mat4 openfl_Matrix;\n\t\tuniform vec2 openfl_TextureSize;\n\t\tuniform vec2 offset;\n\t\tvarying vec4 textureCoords;\n\n\t\tvoid main(void) {\n\t\t\tgl_Position = openfl_Matrix * openfl_Position;\n\t\t\ttextureCoords = vec4(openfl_TextureCoord, openfl_TextureCoord - offset / openfl_TextureSize);\n\t\t}\n\t";
	}
	(openfl_filters_BitmapFilterShader().default).call(this);
	this.offset.value = [0,0];
	this.__isGenerated = true;
	this.__initGL();
}

// Meta

InnerCombineKnockoutShader.__name__ = "openfl.filters._GlowFilter.InnerCombineKnockoutShader";
InnerCombineKnockoutShader.__isInterface__ = false;
InnerCombineKnockoutShader.__super__ = (openfl_filters_BitmapFilterShader().default);
InnerCombineKnockoutShader.prototype = $extend((openfl_filters_BitmapFilterShader().default).prototype, {
	
});
InnerCombineKnockoutShader.prototype.__class__ = InnerCombineKnockoutShader.prototype.constructor = $hxClasses["openfl.filters._GlowFilter.InnerCombineKnockoutShader"] = InnerCombineKnockoutShader;

// Init



// Statics




// Export

exports.default = InnerCombineKnockoutShader;